<template>
  <div class="observa4-results-pellet-print">
    <div v-for="(page, i) in displayContent"
         class="observa4-results-print-page"
         :key="`page-${i}`">
      <div class="header-section" v-if="page.header">
        <print-header
            :year="year"
            :counts="counts"
            :viewType="viewType"
            :subTitle="subTitle"
            :complianceLadder="complianceLadder">
        </print-header>
      </div>

      <div class="row">
        <div :class="`col-xs-12 result-header-${page.style}`">
          <h4>{{ page.title }}</h4>
          <h6>{{ page.subtitle }}</h6>
        </div>
      </div>

      <div class="content-section">
        <div v-for="(section, j) in page.sections"
         :key="`page-${i}-section-${j}`">
          <div class="row">
            <div :class="`col-xs-12 result-header-${section.class}`">
              <h5>{{ section.title }}</h5>
            </div>
          </div>
          <div class="item-container">
            <div v-for="(item, k) in section.values"
                 :key="`page-${i}-section-${j}-item-${k}`"
                 class="padded-content">
              <div :class="`result-content-${section.class}`">
                <div class="item">
                  <div class="pellet-container">
                    <o4-pellet :data="item" pelletSize="std" :showSubtitle="false">
                    </o4-pellet>
                    <div class="item-ratio text-center"
                          v-html="item.splittedText.sampleRatio"></div>
                    <div v-if="item.splittedText.lowSampleSizeText"
                         class="text-center">
                      <div class="label label-warning">
                        <small>
                          <strong><span class="glyphicon glyphicon-exclamation-sign"></span>
                          Effectif faible *</strong>
                        </small>
                      </div>
                    </div>
                  </div>
                  <div class="legend">
                    <div>
                      <h4 v-if="item.st">{{item.st}}</h4>
                      <p class="legend-compliance"
                         v-html="item.splittedText.complianceText"></p>
                    </div>
                    <div>
                      <div class="legend-denominator"
                           v-html="item.splittedText.denominatorText"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import assert from '@/sui/tools/assert'
import o4Pellet from '@/sui/components/results/observa4Pellet'
import sc from '@/sui/components/results/sc/observa4'
import printHeader from '@/sui/components/results/observa4PrintHeader'

export default {
  name: 'print-o4-result-pellet-view',

  props: {
    subTitle: {
      type: String,
      required: true
    },

    data: {
      type: Object,
      required: true
    },

    counts: {
      type: Object,
      required: true
    },

    complianceLadder: {
      type: Object,
      required: true
    },

    viewType: {
      type: String,
      required: true
    },

    year: {
      type: Number,
      required: true
    }
  },

  data: function () {
    return {
      sc: sc
    }
  },

  computed: {
    mainContent: function () {
      const view = this.viewType
      const data = this.data
      if (view == null || data == null) {
        return null
      }

      return data[view]
    },

    displayContent: function () {
      const data = this.mainContent
      if (data == null) {
        return []
      }

      const result = []
      let page = {
        header: true,
        sections: []
      }
      const linesPerPage = 5

      function startNewPage () {
        result.push(page)
        page = {
          header: false,
          sections: []
        }
        remainingLines = linesPerPage
      }

      let remainingLines = linesPerPage - 1

      const keys = Object.keys(data)
      for (let i = 0; i !== keys.length; ++i) {
        const category = keys[i]
        const subCategories = data[category]

        for (let j = 0; j !== subCategories.length; ++j) {
          const subCategory = subCategories[j]
          const values = subCategory.values
          const lines = Math.ceil(values.length / 2.0)
          remainingLines -= lines
          if (remainingLines < 0) {
            startNewPage()
            assert(remainingLines >= lines)
            remainingLines -= lines
          }

          if (page.style == null) {
            page.style = category
            page.title = sc.cat[this.viewType][category]
            page.subtitle = sc.subTitles[this.viewType][category]
          }
          page.sections.push(subCategory)
        }
        startNewPage()
      }

      return result
    }
  },

  components: {
    'o4-pellet': o4Pellet,
    'print-header': printHeader
  }
}

</script>

<style scoped>
.observa4-results-print-page {
  padding: 0.4cm;

  .content-section {
    .item-container {
      display: grid;
      grid-template-columns: 50% 50%;
      grid-template-rows: auto;
      grid-row-gap: 0.15cm;
      margin-bottom: 0.15cm;

      .item {
        display: flex;
        height: 100%;
      }
    }

    .padded-content {
      min-height: 130px;

      padding-right: 0.5rem;
      padding-left: 0.5rem;
    }

    .pellet-container {
      margin-top: 0.25cm;
      margin-bottom: 0.20cm;
      margin-left: 0.2cm;
      margin-right: 0.2cm;
      text-align: center;
    }

    .legend {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding: 0.3cm;
      height: 100%;
    }

    .legend-compliance {
      font-weight: bold;
    }
  }
}

</style>
